


var order_updated = {						
						'AjaxAddOrderItemWithShipingInfo':'AjaxAddOrderItemWithShipingInfo',
						'AjaxDeleteOrderItem':'AjaxDeleteOrderItem',
						'AjaxUpdateOrderItem':'AjaxUpdateOrderItem',
						'AjaxUpdateOrderShippingInfo':'AjaxUpdateOrderShippingInfo',
						'AjaxOrderCalculate':'AjaxOrderCalculate',
						'AjaxLogoff':'AjaxLogoff',
						'AjaxSetPendingOrder':'AjaxSetPendingOrder',
						'AjaxUpdatePendingOrder':'AjaxUpdatePendingOrder',
						'AjaxSingleOrderCancel':'AjaxSingleOrderCancel',
						'AjaxUpdateRewardOption':'AjaxUpdateRewardOption'

											};

var order_updated_2 = {	'AjaxAddOrderItem':'AjaxAddOrderItem',
						'AddOrderItem':'AddOrderItem',
						'AddDonationItem':'AddDonationItem',
						'AjaxUpdateOrderItem':'AjaxUpdateOrderItem',
						'AjaxOrderCalculate':'AjaxOrderCalculate'};

var dropdownUpdated = false;
var dropdownInit = false;
var timer;

var productAddedList = new Object();

wc.render.declareContext("MiniShoppingCartContext",{status:"init"},"");

wc.render.declareContext("MiniShopCartContentsContext",{status:"init", relativeId:"", contentId:"" ,contentType:""},"");

wc.render.declareContext("MiniShopCartDropDownContext",null,"");

function showMiniShopCartDropDownEvent(event,relativeId,contentId,contentType){
	console.debug(event.keyCode);
	if(event.keyCode == dojo.keys.DOWN_ARROW || event.keyCode == dojo.keys.ENTER){
		showMiniShopCartDropDown(relativeId,contentId,contentType);
		dojo.stopEvent(event);
	}
}

function toggleMiniShopCartDropDownEvent(event,relativeId,contentId,contentType){
	console.debug(event.keyCode);
	if(event.keyCode == dojo.keys.DOWN_ARROW || event.keyCode == dojo.keys.ENTER){
		toggleMiniShopCartDropDown(relativeId,contentId,contentType);
		dojo.stopEvent(event);
	}
}

function showMiniShopCartDropDown(relativeId,contentId,contentType){	
	if(!dropdownInit){
		dropdownInit = true;		
		if(!dropdownUpdated){				
			destroyDialog();
			var params = {};
			params["status"] = 'load';		
			params["relativeId"] = relativeId;	
			params["contentId"] = contentId;	
			params["contentType"] = contentType;	
			params["page_view"] = 'dropdown';	

						wc.render.updateContext("MiniShopCartContentsContext", params);		

					} else {			
			positionMiniShopCartDropDown(relativeId,contentId,contentType);						
		}

			}

}

function toggleMiniShopCartDropDown(relativeId,contentId,contentType){
	if (dojo.hasClass(relativeId, "selected")) {		
		var content = dijit.byId(contentId);
		if (content) {
			content.hide();
		}
		$('#mini-cart').css('visibility', 'visible');
	}
	else {		
		showMiniShopCartDropDown(relativeId,contentId,contentType);		
		$('#mini-cart').css('visibility', 'visible')
	}

		  if($("div.petco-checkout #continueReviewPage").hasClass("disabled")){
	 		 if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
	 			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').addClass("disabled");
	 		 }
	 	  }else{
	 		  if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
	  			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').removeClass("disabled");
	  		 }  
	 	  }
}

function positionMiniShopCartDropDown (relativeId,contentId,contentType){	
	var dialog = null;
	var otherDialog = null;
	if(contentType == 'orderItemsList' || contentType == 'orderItemsListAutoClose'){
		dialog = dropDownDlg;
		otherDialog = productAddedDropDownDlg;
	} else if(contentType == 'orderItemAdded'){
		dialog = productAddedDropDownDlg;
		otherDialog = dropDownDlg;	
	}

	var t = dojo.byId(relativeId);
	var c = dojo.coords(t,true);
	var x1 = c.x + 60;
	var y1 = 70;

	var cartWidth =dojo.coords(dojo.byId('mini-cart-icon'),true).w;

		if(dojo.isIE == 8){			
		cartWidth = dojo.coords(dojo.byId('mini-cart-icon'),true).w
	}else if (dojo.isIE>=7 && dojo.isIE<8) {
		cartWidth =dojo.coords(dojo.byId('miniShopCartBody'),true).w;
	}else if(dojo.isIE < 7){
		cartWidth = originalMiniCartWidth;
	}


    var dlgX=x1; 

    if(dojo.isIE){
    	dlgX = x1 + dojo.contentBox(dojo.byId(relativeId)).w-cartWidth;
    }

    	if(dojo.locale == 'ar-eg' || dojo.locale=='iw-il'){
		dlgX = dlgX + 50;
	}

		if(dialog){
			dialog.y = y1;
			dialog.x = dlgX;
	}

		var show = function() {
		deactivate(document.getElementById("header"));
		dojo.addClass("mini-cart-icon", "selected");
	};
	var hide = function() {
		dojo.removeClass("mini-cart-icon", "selected");
	};

	if(!dialog){
		var pane = document.getElementById(contentId);
		var dialogTitleElement = document.getElementById(contentId + "_ACCE_Label");
		if (dialogTitleElement != null) {
			dialog = new wc.widget.WCDialog({relatedSource: relativeId, x:x1, y:y1, title:dialogTitleElement.innerHTML, onShow:show, onHide:hide},pane);
		} else {
			dialog = new wc.widget.WCDialog({relatedSource: relativeId, x:x1, y:y1, onShow:show, onHide:hide},pane);
		}

				dialog.x=dlgX;
	}

	var status = null;
	if(otherDialog){
		status = otherDialog.displayStatus;
	}

		if(!dialog.displayStatus && (status == null || !status)){

				dialog.closeOnTimeOut = false; 
		dialog.autoClose = false; 
		if(contentType == 'orderItemsList' || contentType == 'orderItemsListAutoClose'){
			dropdownDisplayed = true;
			if (contentType == 'orderItemsListAutoClose') {
				dialog.autoClose = true;
			}
			dropDownDlg = dialog;
			setTimeout(dojo.hitch(dropDownDlg,"show",null),5);			
		} else if(contentType == 'orderItemAdded'){
			productAddedDropDownDlg = dialog;
			setTimeout(dojo.hitch(productAddedDropDownDlg,"show",null),5);			
		}
		setTimeout(dojo.hitch(this,"hideUnderlayWrapper",""),5);
	}
	if(dojo.isIE < 7)
	{	
		dialog.style.display = "block";
	}
	dropdownInit = false;
	  if($("div.petco-checkout #continueReviewPage").hasClass("disabled")){
 		 if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
 			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').addClass("disabled");
 		 }
 	  }else{
 		  if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
  			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').removeClass("disabled");
  		 }  
 	  }
}

function setMiniShopCartControllerURL(url){
	  wc.render.getRefreshControllerById('MiniShoppingCartController').url = url;
}


wc.render.declareRefreshController({
       id: "MiniShoppingCartController",
       renderContext: wc.render.getContextById("MiniShoppingCartContext"),
       url: "",
       formId: ""

       ,modelChangedHandler: function(message, widget) {
              var controller = this;
              var renderContext = this.renderContext;              
              if(message.actionId in order_updated || message.actionId == 'AjaxDeleteOrderItemForShippingBillingPage'){
                     var param = [];
                     if(message.actionId == 'AddOrderItem'){                    	 	
                            param.addedOrderItemId = message.orderItemId + "";
                            showDropdown = true;
                            var availableInfoOrderItemIds = "";
                            for(productId in productAddedList){
                            	if(availableInfoOrderItemIds != ""){ 
                            		availableInfoOrderItemIds += ",";
                            	}
                            	availableInfoOrderItemIds += productId;
                            }
                            param.availableInfoOrderItemIds = availableInfoOrderItemIds;                           
                     }                      


                                                               param.deleteCartCookie = true; 

                     dropdownInit = false;  
                     dropdownUpdated = false;


             					               }
       }


       ,renderContextChangedHandler: function(message, widget) {
		    var controller = this;
		    var renderContext = this.renderContext;

		    if(controller.testForChangedRC(["status"])){
				renderContext.properties.deleteCartCookie = true;				
		    	widget.refresh(renderContext.properties);		 		    	 	
		    }	
       }       	   

       ,postRefreshHandler: function(widget) {    	  
              var controller = this;
              var renderContext = this.renderContext;             

                           destroyDialog("MiniShopCartProductAdded");              
              if(showDropdown){            	       			
            	    positionMiniShopCartDropDown("mini-cart-icon",'MiniShopCartProductAdded','orderItemAdded');
                    showDropdown = false;
              }


							updateCartCookie();


						populateProductAddedDropdown();



					resetDeleteCartCookie();
		updateUserCookie();
       }

})

wc.render.declareRefreshController({
       id: "MiniShopCartContentsController",
       renderContext: wc.render.getContextById("MiniShopCartContentsContext"),
       url: "",
       formId: ""

       ,modelChangedHandler: function(message, widget) {
			var controller = this;
			var renderContext = this.renderContext;

			 if(message.actionId in order_updated_2){
				 var param = [];
                 if(message.actionId == 'AddOrderItem'){                 	 	
                        param.addedOrderItemId = message.orderItemId + "";
                        showDropdown = true;
                        var availableInfoOrderItemIds = "";
                        for(productId in productAddedList){
                        	if(availableInfoOrderItemIds != ""){ 
                        		availableInfoOrderItemIds += ",";
                        	}
                        	availableInfoOrderItemIds += productId;
                        }
                        param.availableInfoOrderItemIds = availableInfoOrderItemIds;  


                                                                 }                       
                 param.deleteCartCookie = true;                  
                 widget.refresh(param);

			 	 			 }
       }


       ,renderContextChangedHandler: function(message, widget) {
		    var controller = this;
		    var renderContext = this.renderContext;

		    if(!dropdownUpdated){
		    	var miniCartContent = document.getElementById("MiniShopCartContents");
				var loaderContent = document.getElementById("petco-loading");
				if (miniCartContent!=null && miniCartContent != undefined && loaderContent!=null && loaderContent != undefined) {
					miniCartContent.style.display="none";
					loaderContent.style.display="block";
				}
				renderContext.properties.fetchCartContents = true;
				dropdownUpdated = true;
		    	widget.refresh(renderContext.properties);
		    }	
       }       	   

       ,postRefreshHandler: function(widget) {
    	  if($("div.petco-checkout #continueReviewPage").hasClass("disabled")){
    		 if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
    			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').addClass("disabled");
    		 }
    	  }else{
    		  if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 ){
     			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').removeClass("disabled");
     		 }  
    	  }
            var controller = this;
            var renderContext = this.renderContext;
            var miniCartContent = document.getElementById("MiniShopCartContents");
			var loaderContent = document.getElementById("petco-loading");
			if (miniCartContent!=null && miniCartContent != undefined && loaderContent!=null && loaderContent != undefined) {
				miniCartContent.style.display="block";
				loaderContent.style.display="none";
			}
            destroyDialog("MiniShopCartProductAdded");              
            if(showDropdown){            	                 	          	              	
            	$('#mini-cart').css('visibility', 'visible');
          	    positionMiniShopCartDropDown("mini-cart-icon",'MiniShopCartProductAdded','orderItemAdded');            	 

	      			                showDropdown = false;
                dropdownInit = true; 
                dropdownUpdated = false; 
            } else {
            }

    		    			updateCartCookie();


    		    		    		populateProductAddedDropdown();    		


    		    			resetDeleteCartCookie();

    		    		var CartId = dojo.cookie('WC_CartOrderId_10151');
            var cart = 'WC_CartTotal_'.concat(CartId);
            var cartTotalCookie = dojo.cookie('rCartTotal');
			if(cartTotalCookie!=null && cartTotalCookie != '0'){
            	document.getElementById('cart-count').innerHTML = cartTotalCookie;
            	document.getElementById('mobile-cart-count').innerHTML = cartTotalCookie;
            	if(document.getElementById('persistent-cart-count') != null) {
            		document.getElementById('persistent-cart-count').innerHTML = cartTotalCookie;
            	}
			}else{
				if(document.getElementById('cart-count')!= null){
				  document.getElementById('cart-count').innerHTML = "";
				}
				if(document.getElementById('mobile-cart-count')!= null){
				   document.getElementById('mobile-cart-count').innerHTML = "";
				}
				if(document.getElementById('persistent-cart-count') != null) {
					document.getElementById('persistent-cart-count').innerHTML = "";
				}
			}
			updateUserCookie();
			cursor_clear();
       }

})

function updateCartCookie(){
		 if(document.getElementById("currentOrderQuantity") != null && document.getElementById("currentOrderAmount") != null
			&& document.getElementById("currentOrderCurrency") != null && document.getElementById("currentOrderId") != null
			&& document.getElementById("currentOrderLanguage") != null) {
				var cartQuantity = document.getElementById("currentOrderQuantity").value;
				var cartAmount = document.getElementById("currentOrderAmount").value;
				var cartCurrency = document.getElementById("currentOrderCurrency").value;
				var cartLanguage = document.getElementById("currentOrderLanguage").value;
				var cartOrderId = document.getElementById("currentOrderId").value; 
				var domain = "";
				if(dojo.byId('cookieDomain') != null){
					domain = dojo.byId('cookieDomain').value;
				}
				var freshPetInCartQuantity = 0;
				if(document.getElementById("currentOrderFreshPetQuantity") != null){
					freshPetInCartQuantity = document.getElementById("currentOrderFreshPetQuantity").value;
				}
				var orderIdCookie = getCookie("WC_CartOrderId_"+WCParamJS.storeId);
				if(orderIdCookie != null){
					dojo.cookie("WC_CartOrderId_"+WCParamJS.storeId, null, {expires:-1,path:'/'});
					var cartTotalCookie = getCookie("WC_CartTotal_"+orderIdCookie);
					if(cartTotalCookie != null){
						dojo.cookie("WC_CartTotal_"+orderIdCookie, null, {expires:-1,path:'/'});
					}	
					var cartRTotalCookie = getCookie("rCartTotal");
					if(cartRTotalCookie != null){
						dojo.cookie("rCartTotal", null, {expires:-1,path:'/',domain:domain});
					}
				}
				dojo.cookie("WC_CartOrderId_"+WCParamJS.storeId, cartOrderId, {path:'/'});
				if(cartOrderId != ""){
					dojo.cookie("WC_CartTotal_"+cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage, {path:'/'});
					dojo.cookie("rCartTotal", (cartQuantity - freshPetInCartQuantity), {path:'/',domain:domain});
				}					      
		 }
}

function updateCartCookiefromShopCart(){
		var cartOrderId = document.getElementById("currentOrderIdShop").value;
		var cartQuantity = document.getElementById("currentOrderQuantityShop").value;
		var freshPetInCartQuantity = 0;
		if(document.getElementById("currentOrderFreshPetQuantity") != null){
			freshPetInCartQuantity = document.getElementById("currentOrderFreshPetQuantity").value;
		} 
		if(cartQuantity = '1'){
			updateCartCookie();
		}
		if(cartQuantity != '1'){
		    var orderIdCookie = getCookie("WC_CartOrderId_"+WCParamJS.storeId);
		    var domain = "";
			if(dojo.byId('cookieDomain') != null){
				domain = dojo.byId('cookieDomain').value;
			}
				if(orderIdCookie != null){
					dojo.cookie("WC_CartOrderId_"+WCParamJS.storeId, null, {expires:-1,path:'/'});
					var cartTotalCookie = getCookie("WC_CartTotal_"+orderIdCookie);
					if(cartTotalCookie != null){
						dojo.cookie("WC_CartTotal_"+orderIdCookie, null, {expires:-1,path:'/'});
					}	
					var cartRTotalCookie = getCookie("rCartTotal");
					if(cartRTotalCookie != null){
						dojo.cookie("rCartTotal", null, {expires:-1,path:'/',domain:domain});
					}
				}
				dojo.cookie("WC_CartOrderId_"+WCParamJS.storeId, cartOrderId, {path:'/'});
				if(cartOrderId != ""){
					dojo.cookie("WC_CartTotal_"+cartOrderId, cartQuantity-1 + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage, {path:'/'});
					dojo.cookie("rCartTotal", (cartQuantity - freshPetInCartQuantity), {path:'/',domain:domain});
				}
		}

		}
function checkIfCheckoutButtonIsDisabled_minicart(){
	var disabled = false;
	 if($('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').length > 0 &&
			 $('a.btn-primary[manual_cm_sp="Header-_-Cart-_-Checkout"]').hasClass("disabled")){
		 disabled = true;
		 }  
	 return disabled;
}
function setProductAddedList(newProductAddedList) {
	productAddedList = newProductAddedList;
}
function populateProductAddedDropdown(){

				var search = '"';

				var replaceStr = '\\\\"';
		for(productId in productAddedList){
			var productDetails = productAddedList[productId];

						if(document.getElementById('MiniShopCartAddedProdName_'+productId) != null && productDetails[0] != null){
				document.getElementById('MiniShopCartAddedProdName_'+productId).innerHTML = productDetails[0];
			}
			if(document.getElementById('MiniShopCartAddedProdImgSrc_'+productId) != null && productDetails[1] != null){
				document.getElementById('MiniShopCartAddedProdImgSrc_'+productId).src = productDetails[1];
				document.getElementById('MiniShopCartAddedProdImgSrc_'+productId).alt = productDetails[0];
			}
			if(document.getElementById('MiniShopCartAddedProdPrice_'+productId) != null && productDetails[2] != null){
				document.getElementById('MiniShopCartAddedProdPrice_'+productId).innerHTML = productDetails[2];
			}
			if(document.getElementById('MiniShopCartAddedProdQty_'+productId) != null && productDetails[3] != null){
				document.getElementById('MiniShopCartAddedProdQty_'+productId).innerHTML = productDetails[3];
			}		

						if(document.getElementById('MiniShopCartAddedProdAttr_'+productId) != null && productDetails[4] != null){
				document.getElementById('MiniShopCartAddedProdAttr_'+productId).innerHTML = "";

				for(attrName in productDetails[4]){
					attrValue = productDetails[4][attrName]
					if (attrValue != null && attrValue !='undefined'){
						attrValue = attrValue.replace(replaceStr, search).replace(/&amp;/g,"&").replace(/&#039;/g,"'").replace(/&#034;/g,'"');
					}
					document.getElementById('MiniShopCartAddedProdAttr_'+productId).innerHTML += '<div>'
						+ attrName + ': ' + attrValue  + '</div>';
				}
			}
		}
		dojo.topic.publish("ProductInfo_Reset");
}

function loadMiniCart(contextCurrency, langId) {
		var updateCart = false;

				var orderIdCookie = getCookie("WC_CartOrderId_"+WCParamJS.storeId);		
		var itemsKey = null;

				if(checkDeleteCartCookie()){
			updateCart = true;
		} else if(orderIdCookie != undefined && orderIdCookie == ""){
			var subtotal = document.getElementById("minishopcart_subtotal");
			var formattedSubtotal = null;
			if (dojo.locale == 'iw-il') {
				formattedSubtotal = dojo.currency.format(document.getElementById("currentOrderAmount").value,
						{symbol: 'symbol', currency:contextCurrency, locale:'he'});
			} else {
				formattedSubtotal = dojo.currency.format(document.getElementById("currentOrderAmount").value,
						{symbol: 'symbol', currency:contextCurrency});
			}

						if(formattedSubtotal != null){
				formattedSubtotal = formattedSubtotal.replace('symbol', shoppingActionsJS.currencySymbol);			
			} else {
				formattedSubtotal = document.getElementById("currentOrderAmount").value;
			}

						if(subtotal != null){
				subtotal.innerHTML = "\n " 
				+ formattedSubtotal
				+ "\n ";
			}
			var items = document.getElementById("minishopcart_total");
			if(items != null){
				var itemsMsg = document.getElementById("currentOrderQuantity").value;
				if(itemsKey != null) {
					itemsMsg = dojo.string.substitute(itemsKey, {0: document.getElementById("currentOrderQuantity").value});
				}
				items.innerHTML = "\n " 
				+ itemsMsg
				+ "\n ";
			}			
		} else if (orderIdCookie != undefined && orderIdCookie != ""){
			var cartCookie = getCookie("WC_CartTotal_"+orderIdCookie);

				if(cartCookie != undefined && cartCookie != null && cartCookie != ""){
					var orderInfo = cartCookie.split(";");

										if(orderInfo != null && orderInfo.length == 4){
						if(orderInfo[2] == contextCurrency && orderInfo[3] == langId){
							var subtotal = document.getElementById("minishopcart_subtotal");
							if(subtotal != null){
								var formattedSubtotal = null;
								if (dojo.locale == 'iw-il') {
									formattedSubtotal = dojo.currency.format(orderInfo[1].toString(),
											{symbol: 'symbol', currency:contextCurrency, locale: 'he'});
								} else {
									formattedSubtotal = dojo.currency.format(orderInfo[1].toString(),
											{symbol: 'symbol', currency:contextCurrency});
								}
								if(formattedSubtotal != null){
									formattedSubtotal = formattedSubtotal.replace('symbol', shoppingActionsJS.currencySymbol);
								} else {
									formattedSubtotal = orderInfo[1].toString(); 
								}
								subtotal.innerHTML = "\n " 
								+ formattedSubtotal
								+ "\n ";
							}

														var items = document.getElementById("minishopcart_total");
							if(items != null){
								var itemsMsg = orderInfo[0].toString();
								if(itemsKey != null) {
									itemsMsg = dojo.string.substitute(itemsKey, {0: orderInfo[0].toString()});
								}							
								items.innerHTML = "\n " 
								+ itemsMsg
								+ "\n ";
							}

													} else {
							updateCart = true;
						}
					} else {
						updateCart = true;
					}
				} else {
					updateCart = true;
				}
		} else {
			updateCart = true;
		}
		if(updateCart == true){
			wc.render.updateContext('MiniShopCartContentsContext', {'status':'load'});
		}
}

function handleMiniCartHover() {
		dojo.connect(document.getElementById("mini-cart-icon"), "onmouseover", function() {
			timer = setTimeout(function(){showMiniShopCartDropDown('mini-cart-icon','quick_cart_container','orderItemsListAutoClose')}, 1000);
		});
		dojo.connect(document.getElementById("mini-cart-icon"), "onmouseout", function() {
			clearTimeout(timer);
		});	
}

function setDeleteCartCookie(){
	dojo.cookie("WC_DeleteCartCookie_"+WCParamJS.storeId, true, {path:'/'});
}

function checkDeleteCartCookie(){
	var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_"+WCParamJS.storeId);	

		if(deleteCartCookieVal != undefined && deleteCartCookieVal != ""){
		if(deleteCartCookieVal == 'true'){
			return true;
		}
	}
	return false;
}

function resetDeleteCartCookie(){
	var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_"+WCParamJS.storeId);

		if(deleteCartCookieVal != null){
		dojo.cookie("WC_DeleteCartCookie_"+WCParamJS.storeId, null, {expires:-1,path:'/'});
		dojo.cookie("WC_DeleteCartCookie_"+WCParamJS.storeId, null, {expires:-1,path:'/',domain:document.location.hostname});
	}
}


function updateUserCookie(){

	var deleteCartCookieVal = getCookie("WC_UserId");

	if(deleteCartCookieVal != undefined && deleteCartCookieVal != ""){

		var userId = dojo.byId('userId').value;

		if(deleteCartCookieVal != userId){

			dojo.cookie("WC_UserId", userId, {path:'/'});

		}

	}

	else{

		if(dojo.byId('userId') != undefined){

			var userId = dojo.byId('userId').value;

			dojo.cookie("WC_UserId", userId, {path:'/'});

		}

		else{

			dojo.cookie("WC_UserId", "-1002", {path:'/'});

		}

	}

} 

function reinitializeCartCounts() {
	var CartId = dojo.cookie('WC_CartOrderId_'.concat(WCParamJS.storeId));
	var cartTotalCookie = dojo.cookie('WC_CartTotal_'.concat(CartId));
	if (cartTotalCookie != null) {
		var cartTotal = cartTotalCookie.split(';');
		if (document.getElementById('cart-count')) {
			document.getElementById('cart-count').innerHTML = cartTotal[0];
		}
		if (document.getElementById('persistent-cart-count')) {
			document.getElementById('persistent-cart-count').innerHTML = cartTotal[0];
		}
		if (document.getElementById('mobile-cart-count')) {
			document.getElementById('mobile-cart-count').innerHTML = cartTotal[0];
		}
	}
}
function forwardToCheckout(url){
	document.location.href=url;
}

dojo.topic.subscribe("ProductInfo_Added", setProductAddedList);